(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
  /* Clips erst laden, wenn sie fast sichtbar sind.
     rootMargin 200px: die Quelle wird knapp VOR dem Sichtbarwerden gesetzt,
     damit das erste Bild schon steht, wenn die Kachel ankommt. Wer erst beim
     Eintreten laedt, zeigt jedem ein kurzes Standbild-Zucken. */
  (function () {
    var wurzel = document.documentElement;
    if (wurzel.classList.contains('reduced-motion')) return;
    if (!('IntersectionObserver' in window)) return;

    var beob = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        if (!v.src && v.dataset.spaetVideo) {
          v.src = v.dataset.spaetVideo;
          var p = v.play();
          if (p && p.catch) p.catch(function () { /* Browser sagt nein, ok */ });
        }
        beob.unobserve(v);
      });
    }, { rootMargin: '200px 0px' });

    document.querySelectorAll('[data-spaet-video]').forEach(function (v) {
      beob.observe(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Der Wartelisten-Knopf springt nicht nur hin, er setzt auch den
     Schreibkopf ins Feld. Ohne das landet man an der richtigen Stelle und
     muss trotzdem noch einmal tippen -- ein Schritt, den man sich sparen
     kann und der bei jedem zweiten Besucher der letzte ist. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-zur-warteliste]');
    if (!a) return;
    var feld = document.querySelector('#wl-mail');
    if (!feld) return;                       /* dann bleibt der normale Sprung */
    e.preventDefault();
    var ziel = feld.closest('section') || feld;
    ziel.scrollIntoView({ block: 'center',
      behavior: document.documentElement.classList.contains('reduced-motion')
        ? 'auto' : 'smooth' });
    /* Erst nach dem Scrollen fokussieren, sonst springt Safari zurueck. */
    setTimeout(function () { feld.focus({ preventScroll: true }); }, 420);
  });


  /* Pause-Knopf. Der einzige Zweck: Apples Vorgabe erfuellen, dass sich
     bewegtes Bild anhalten laesst. Der Zustand steht im Knopf selbst,
     damit Vorlese-Software ihn mitbekommt. */
  document.querySelectorAll('[data-video-pause]').forEach(function (knopf) {
    var video = knopf.closest('.hero').querySelector('video');
    if (!video) { knopf.hidden = true; return; }
    knopf.addEventListener('click', function () {
      if (video.paused) { video.play(); knopf.dataset.zustand = 'laeuft'; }
      else { video.pause(); knopf.dataset.zustand = 'pausiert'; }
      knopf.setAttribute('aria-pressed', video.paused ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt"]) return;
  try {
    
  /* Variantenwahl. Bewusst klein und ohne Framework:
     Radios lesen -> passende Variante suchen -> versteckte ID, Preis und Bild
     setzen. Wenn eine Kombination nicht existiert, bleibt die alte ID stehen
     und der Kaufknopf sagt es beim Klick, statt sich auszugrauen. */
  /* NEU ANLAUFEN, WENN SHOPIFY DIE SEKTION NEU ZEICHNET.

     Im Theme-Editor wird eine Sektion bei jeder Aenderung komplett neu ins
     DOM gesetzt. Dieses Skript laeuft aber nur EINMAL beim Laden der Seite
     und haelt danach feste Verweise auf Elemente, die es dann nicht mehr
     gibt: pdp, idFeld, preisFeld, hauptbild, meldenBlock, leiste.
     Ergebnis: Robin aendert einen Text, und ab da tut die Variantenwahl
     nichts mehr -- ohne Fehlermeldung, nur im Editor, nicht im Laden.
     Genau das kostet eine Stunde Suche am falschen Ende.

     apple-fundament.js loest dieselbe Falle fuer sich schon; hier war es
     nicht uebertragen. Die Doppelregistrierung ist kein Problem, weil die
     Verweise beim Neulauf frisch geholt werden und die Horcher an den NEUEN
     Elementen haengen -- die alten sind mit ihrem DOM verschwunden.
     Ausnahme sind die beiden Horcher auf `document` weiter unten; die
     tragen deshalb eine Sperre. */
  function pdpStarten() {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

    var datenknoten = document.querySelector('[data-varianten]');
    if (!datenknoten) return;

    /* JSON.parse MIT NETZ.
       Am 08.09.2026 hat genau diese Zeile den ganzen Kaufweg gekostet:
       Liquid hatte eine Fehlermeldung in den Datenblock geschrieben, der
       Parser warf, und ab da lief kein Zeichen dieses Skripts mehr. Die
       versteckte Varianten-ID blieb auf der ersten Variante stehen -- Farbe
       und Groesse zu waehlen bewirkte nichts.

       Die Ursache ist behoben. Diese Sperre steht trotzdem hier, denn die
       naechste Aenderung am Datenblock kann denselben Fehler neu erzeugen,
       und dann darf nicht wieder ALLES sterben: Bildstreifen, klebende
       Leiste und Meldeblock haengen an derselben Funktion.
       Der Fehler wird ausdruecklich in die Konsole geschrieben -- still
       scheitern ist genau das, was hier schon einmal passiert ist. */
    var varianten;
    try {
      varianten = JSON.parse(datenknoten.textContent);
    } catch (fehler) {
      console.error('Variantendaten unlesbar — Variantenwahl bleibt aus:',
                    fehler, datenknoten.textContent.slice(0, 200));
      return;
    }
    if (!Array.isArray(varianten) || !varianten.length) return;

    var idFeld     = pdp.querySelector('[data-varianten-id]');
    var preisFeld  = pdp.querySelector('[data-preis]');
    var leistePreis = document.querySelector('[data-leiste-preis]');
    var hauptbild  = pdp.querySelector('[data-hauptbild] img');

    function gewaehlteOptionen() {
      var werte = [];
      pdp.querySelectorAll('input[type=radio][data-option-index]:checked').forEach(function (r) {
        werte[parseInt(r.dataset.optionIndex, 10)] = r.value;
      });
      return werte;
    }

    function passt(v, werte) {
      for (var i = 0; i < werte.length; i++) {
        if (werte[i] !== undefined && v.optionen[i] !== werte[i]) return false;
      }
      return true;
    }

    /* Index der Groessenoption aus dem DOM lesen statt aus Liquid
       durchzureichen -- so bleibt das JS unabhaengig von der Optionsreihenfolge
       im Shopify-Admin. Findet es keine, ist der Wert -1 und die
       Ausverkauft-Marken bleiben schlicht stehen. */
    var groessenGruppe = pdp.querySelector('[data-pflichtwahl][data-optionsgruppe]');
    var groessenIndex = groessenGruppe
      ? parseInt(groessenGruppe.dataset.optionsgruppe, 10) : -1;

    var meldenBlock = document.querySelector('[data-melden]');

    /* Wie Shopifys handleize: klein, Umlaute aufgeloest, alles andere zu
       Bindestrichen. Ohne die Umlautaufloesung wuerde aus "Weiss" und
       "Weiß" zweimal etwas anderes -- und die Liste haette zwei Segmente
       fuer dieselbe Farbe. */
    function kennzeichnen(text) {
      return String(text).toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function zustandSetzen(kaufbar) {
      document.querySelectorAll('[data-kaufknopf]').forEach(function (knopf) {
        knopf.dataset.hatBestand = kaufbar ? 'true' : 'false';
        var text = kaufbar ? knopf.dataset.textKaufen : knopf.dataset.textMelden;
        if (text) knopf.textContent = text;
        /* Nur der Hauptknopf verschwindet ohne Bestand -- der Meldeblock
           direkt darunter traegt die Handlung dann allein. Der Knopf in
           der klebenden Leiste bleibt: dort gibt es keinen Meldeblock
           daneben, er waere sonst ersatzlos weg. */
        if ('hauptknopf' in knopf.dataset) knopf.hidden = !kaufbar;
      });
      /* Ist die Ware da, verschwindet das Formular wieder -- sonst stehen
         Kaufknopf und "wir sagen Bescheid" gleichzeitig da und widersprechen
         sich. */
      if (meldenBlock && kaufbar && !meldenBlock.querySelector('.melden__danke')) {
        meldenBlock.hidden = true;
      }
    }

    /* Klick auf einen Knopf ohne Bestand kauft nicht, sondern oeffnet die
       Benachrichtigung. Muss VOR dem Absenden greifen, deshalb capture:
       der allgemeine Groessen-Hinweis in apple-fundament.js haengt am selben
       Knopf und darf hier nicht zuerst drankommen. */
    /* Sperre: dieser Horcher haengt an `document` und ueberlebt jedes
       Neuzeichnen. Ohne sie kaeme bei jedem Sektionsladen einer dazu, und
       beim dritten Mal springt die Seite dreimal zum Meldeblock. */
    if (!document.documentElement.dataset.meldeklickVerdrahtet) {
      document.documentElement.dataset.meldeklickVerdrahtet = '1';
      document.addEventListener('click', function (e) {
      var knopf = e.target.closest && e.target.closest('[data-kaufknopf]');
      if (!knopf || knopf.dataset.hatBestand !== 'false') return;
      var meldenBlock = document.querySelector('[data-melden]');
      if (!meldenBlock) return;
      e.preventDefault();
      e.stopPropagation();
      meldenBlock.hidden = false;
      meldenBlock.scrollIntoView({ block: 'center',
        behavior: document.documentElement.classList.contains('reduced-motion')
          ? 'auto' : 'smooth' });
      var feld = meldenBlock.querySelector('[data-melden-mail]');
      if (feld) feld.focus({ preventScroll: true });
      }, true);
    }

    function aktualisieren() {
      var werte = gewaehlteOptionen();
      var treffer = varianten.filter(function (v) { return passt(v, werte); })[0];
      if (!treffer) return;

      if (idFeld) idFeld.value = treffer.id;
      if (preisFeld) preisFeld.innerHTML = treffer.preis;
      if (leistePreis) leistePreis.innerHTML = treffer.preis;
      if (hauptbild && treffer.bild) hauptbild.src = treffer.bild;

      /* Lieferbar oder nicht -- der Knopf wechselt die Aufgabe, nicht die
         Farbe. Grau waere hier falsch: der Besucher soll etwas tun koennen. */
      zustandSetzen(treffer.verfuegbar);

      /* Ausverkauft-Marken je Groesse neu rechnen. Sie haengen an der
         GEWAEHLTEN FARBE: Schwarz M kann da sein, waehrend Weiss M fehlt.
         Wer das nicht nachzieht, zeigt Marken der falschen Farbe an. */
      if (groessenIndex >= 0) {
        pdp.querySelectorAll('[data-groessenkarte]').forEach(function (karte) {
          var groesse = karte.dataset.groessenkarte;
          var kaufbar = varianten.some(function (v) {
            if (v.optionen[groessenIndex] !== groesse) return false;
            if (!v.verfuegbar) return false;
            /* alle ANDEREN gewaehlten Optionen muessen passen */
            for (var i = 0; i < werte.length; i++) {
              if (i === groessenIndex) continue;
              if (werte[i] !== undefined && v.optionen[i] !== werte[i]) return false;
            }
            return true;
          });
          karte.classList.toggle('wahl__karte--leer', !kaufbar);
          var marke = karte.querySelector('[data-leer-marke]');
          if (marke) marke.hidden = kaufbar;
        });
      }

      /* Worauf gewartet wird, wandert in die KENNUNGEN mit -- nicht in eine
         Notiz: `contact[note]` nimmt Shopifys Kundenformular gar nicht an.
         Kennungen sind in der Kundenliste filterbar, eine Notiz nicht. */
      var kennungen = document.querySelector('[data-melden-kennungen]');
      if (kennungen && treffer) {
        var basis = ['warteliste', 'drop-01', kennungen.dataset.griff || ''];
        var namen = kennungen.dataset.optionsnamen
          ? kennungen.dataset.optionsnamen.split('|') : [];
        var zusatz = treffer.optionen.map(function (wert, i) {
          return (namen[i] || ('option' + i)) + '-' + kennzeichnen(wert);
        });
        kennungen.value = basis.filter(Boolean).concat(zusatz).join(',');
      }

      var farbAnzeige = pdp.querySelector('[data-wahlwert-farbe]');
      var farbRadio = pdp.querySelector('input[type=radio][name^="option-"]:checked');
      if (farbAnzeige && farbRadio) farbAnzeige.textContent = farbRadio.value;

      /* Sobald eine Groesse gewaehlt ist, verschwindet der Hinweis wieder. */
      pdp.querySelectorAll('[data-pflichtwahl]').forEach(function (gruppe) {
        if (gruppe.querySelector('input[type=radio]:checked')) {
          gruppe.setAttribute('data-gewaehlt', '');
          gruppe.classList.remove('wahl-fehlt');
          var hinweis = gruppe.querySelector('[data-wahl-hinweis]');
          if (hinweis) hinweis.hidden = true;
        }
      });

      /* Adresszeile mitfuehren, damit ein geteilter Link die richtige
         Variante zeigt. replaceState, damit der Zurueck-Knopf nicht
         durch jede Farbwahl zurueckstolpert. */
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', treffer.id);
        history.replaceState({}, '', url);
      }
    }

    pdp.addEventListener('change', function (e) {
      if (e.target.matches('input[type=radio][data-option-index]')) aktualisieren();
    });

    /* Bildstreifen */
    pdp.querySelectorAll('[data-daumen]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        if (hauptbild) hauptbild.src = knopf.dataset.daumen;
        pdp.querySelectorAll('[data-daumen]').forEach(function (k) { k.classList.remove('ist-aktiv'); });
        knopf.classList.add('ist-aktiv');
      });
    });

    /* Klebende Leiste: erscheint, wenn der Hauptknopf aus dem Bild ist.
       Beobachter statt Scroll-Listener — derselbe Grund wie bei der Nav. */
    var leiste = document.querySelector('[data-kaufleiste]');
    var hauptknopf = pdp.querySelector('.pdp__kaufen');
    if (leiste && hauptknopf && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { leiste.hidden = e.isIntersecting; });
      }, { threshold: 0 }).observe(hauptknopf);
    }
  }

  pdpStarten();
  document.addEventListener('shopify:section:load', pdpStarten);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warteliste"] && !Shopify.designMode) return;
  try {
    
  /* Die gewaehlte Groesse wandert in die Kennungen. Ueber `document`
     angemeldet, damit ein Neuzeichnen der Sektion im Theme-Editor sie nicht
     abhaengt; Sperre dagegen, dass sie doppelt haengt. */
  if (!document.documentElement.dataset.wlGroesseVerdrahtet) {
    document.documentElement.dataset.wlGroesseVerdrahtet = '1';
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-wl-groesse]')) return;
      var kennungen = document.querySelector('[data-wl-kennungen]');
      if (!kennungen) return;
      var basis = ['warteliste', 'drop-01'];
      var wert = (e.target.value || '').trim().toLowerCase();
      if (wert) basis.push('grosse-' + wert.replace(/[^a-z0-9]+/g, '-'));
      kennungen.value = basis.join(',');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zone"] && !Shopify.designMode) return;
  try {
    
  /* Welcher Schritt ist gerade dran?

     Beobachter statt Scroll-Zaehler: ein scroll-Ereignis feuert bei jedem
     Radrasten und zwingt den Browser zum Nachrechnen der Positionen. Ein
     IntersectionObserver rechnet einmal und meldet sich nur bei Aenderung.

     rootMargin schneidet oben und unten je 45 % weg. Uebrig bleibt ein
     schmaler Streifen in der Mitte des Fensters -- "dran" ist, was DORT
     steht. Ohne diese Verengung waeren auf einem hohen Schirm zwei
     Schritte gleichzeitig dran, und der Punkt sagt nichts mehr aus.

     Was passiert ohne JS: gar nichts. Kein Punkt ist gefuellt, alle
     Schritte stehen vollstaendig lesbar da. Der Punkt ist Orientierung,
     nicht Inhalt -- deshalb darf er ausfallen. */
  (function () {
    var schritte = document.querySelectorAll('[data-zschritt]');
    if (!schritte.length || !('IntersectionObserver' in window)) return;

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        e.target.classList.toggle('ist-dran', e.isIntersecting);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    schritte.forEach(function (s) { beobachter.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();
})();
